import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Image as ImageIcon, Wind, Zap, Sparkles } from 'lucide-react';
export function Styling() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-32 pb-24 bg-white min-h-screen" data-id="element-674">
      <div className="container mx-auto px-6 md:px-12" data-id="element-675">
        {/* HERO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center mb-20" data-id="element-676">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-ink mb-6" data-id="element-677">
            Укладка волосся
          </h1>
          <p className="text-muted text-lg md:text-xl font-normal leading-relaxed" data-id="element-678">
            Вечірні, весільні та повсякденні укладки — брашинг, праска або
            плойка залежно від вашого образу.
          </p>
        </motion.div>

        {/* SERVICE TYPES */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-24" data-id="element-679">
          {[{
          icon: <Wind size={24} strokeWidth={1.5} data-id="element-680" />,
          title: 'Брашинг',
          desc: "Об'єм та гладкість для щоденного образу"
        }, {
          icon: <Zap size={24} strokeWidth={1.5} data-id="element-681" />,
          title: 'Укладка праскою',
          desc: 'Ідеальна гладкість та блиск'
        }, {
          icon: <Sparkles size={24} strokeWidth={1.5} data-id="element-682" />,
          title: 'Укладка плойкою',
          desc: 'Локони та хвилі для особливих подій'
        }].map((item, i) => <div key={i} className="bg-white p-8 rounded-[2rem] border border-line shadow-sm flex flex-col items-center text-center" data-id="element-683">
              <div className="text-ink mb-6 p-4 bg-surface rounded-full border border-line" data-id="element-684">
                {item.icon}
              </div>
              <h3 className="text-lg font-semibold text-ink mb-3" data-id="element-685">
                {item.title}
              </h3>
              <p className="text-sm text-muted leading-relaxed" data-id="element-686">{item.desc}</p>
            </div>)}
        </motion.div>

        {/* PRICE SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-2xl mx-auto mb-16" data-id="element-687">
          <div className="text-center mb-12" data-id="element-688">
            <h2 className="font-heading text-3xl font-semibold text-ink mb-4" data-id="element-689">
              Прайс
            </h2>
            <div className="w-12 h-1 bg-ink mx-auto rounded-full" data-id="element-690"></div>
          </div>

          <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-691">
            <ul className="space-y-4" data-id="element-692">
              {[{
              name: 'До середини шиї',
              price: '200 грн'
            }, {
              name: 'До плечей',
              price: '300 грн'
            }, {
              name: 'Нижче плечей',
              price: '400 грн'
            }, {
              name: 'Нижче лопаток',
              price: '500 грн'
            }, {
              name: 'До пояса',
              price: '600 грн'
            }, {
              name: 'Укладочні засоби',
              price: '50–100 грн'
            }].map((item, i) => <li key={i} className="flex justify-between items-center text-base" data-id="element-693">
                  <span className="text-muted" data-id="element-694">{item.name}</span>
                  <span className="font-semibold text-ink" data-id="element-695">{item.price}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        {/* OCCASIONS BLOCK */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-wrap justify-center gap-3 mb-24 max-w-3xl mx-auto" data-id="element-696">
          {['Весілля', 'Випускний', 'Фотосесія', 'Ділова зустріч', 'Щоденний образ'].map((tag, i) => <span key={i} className="px-6 py-2 bg-surface border border-line rounded-full text-sm font-medium text-ink" data-id="element-697">
              {tag}
            </span>)}
        </motion.div>

        {/* PORTFOLIO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mb-24" data-id="element-698">
          <div className="text-center mb-12" data-id="element-699">
            <h2 className="font-heading text-3xl font-semibold text-ink mb-4" data-id="element-700">
              Мої роботи
            </h2>
            <div className="w-12 h-1 bg-ink mx-auto rounded-full" data-id="element-701"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-702">
            {[1, 2, 3].map(i => <div key={i} className="aspect-[3/4] bg-surface rounded-[2rem] border border-line flex items-center justify-center shadow-sm" data-id="element-703">
                <div className="text-center flex flex-col items-center" data-id="element-704">
                  <ImageIcon className="text-muted mb-3" size={32} strokeWidth={1.5} data-id="element-705" />
                  <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-706">
                    Фото роботи
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* CTA SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="max-w-md mx-auto flex flex-col gap-4" data-id="element-707">
          <a href="/#contact" className="w-full py-4 bg-ink text-white text-center text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-708">
            Записатися
          </a>
          <Link to="/#services" className="w-full py-4 border border-line text-ink text-center text-sm font-medium tracking-wide rounded-full hover:bg-surface transition-all duration-300" data-id="element-709">
            До всіх послуг
          </Link>
        </motion.div>
      </div>
    </main>;
}